import React from 'react'
import { Button } from 'antd'
import { useUpdateQuestionAnswerReasoningMutation } from '../../../../../../../../../../store/apis/submission.api'
import ManualSaveTextArea from './ManualSaveTextArea'

const FeedbackInput = ({ 
    submissionId, 
    answerId, 
    feedback: feedbackFromStore, 
    readonly,
    questionRubricId,
    isDraftMode = false,
    onDraftChange,
    showUseForPersonalized,
    onUseForPersonalized,
}) => {
    const [updateQuestionAnswerReasoning, updateQuestionAnswerReasoningResult] = 
        useUpdateQuestionAnswerReasoningMutation()

    const handleSave = reasoning => {
        updateQuestionAnswerReasoning({
            id: answerId,
            submissionId,
            reasoning,
            questionRubricId,
            feedbackType: 'canned',
        })
    }

    const handleValueChange = value => {
        if (isDraftMode) onDraftChange?.(value)
    }

    return (
        <div className={`inline-label-wrapper ${readonly ? 'readonly' : ''}`}>
            <div className="inline-label-textarea" style={{ flexDirection: 'column', alignItems: 'stretch', gap: 6 }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
                    <span className="inline-label-text">Rubric Feedback:</span>
                    {showUseForPersonalized && (
                        <Button
                            type="link"
                            size="small"
                            style={{ padding: 0, height: 'auto' }}
                            onClick={e => {
                                e.stopPropagation()
                                onUseForPersonalized?.()
                            }}
                            data-test="use-canned-feedback-for-personalized-button"
                        >
                            Use
                        </Button>
                    )}
                </div>
                <ManualSaveTextArea
                    initialValue={feedbackFromStore}
                    onSave={handleSave}
                    isLoading={updateQuestionAnswerReasoningResult.isLoading}
                    readonly={readonly}
                    placeholder='Enter rubric feedback for this answer...'
                    className='feedback inline-label-input'
                    title='Rubric Feedback'
                    showButtons={!isDraftMode}
                    onValueChange={handleValueChange}
                />
            </div>
        </div>
    )
}

export default FeedbackInput
